import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";
import TabNav from "../../../CommonComponents/TabNav/TabNav";
import ClubChants from "./ClubChants";

const ClubAdminChants = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [chantsCount, setChantsCount] = useState(0);

  const getCurrentTab = () => {
    if (location.pathname.includes("/archive")) {
      return "archive";
    }
    return "current";
  };

  const menuItems = [
    {
      key: "current",
      label: "Current",
    },
    {
      key: "archive",
      label: "Archive",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "current":
        navigate("/clubadmin/chants");
        break;
      case "archive":
        navigate("/clubadmin/chants/archive");
        break;
      default:
        navigate("/clubadmin/chants");
    }
  };

  const renderContent = () => {
    if (location.pathname.includes("/archive")) {
      return <ClubChants archive={true} setChantsCount={setChantsCount} />;
    }
    return <ClubChants archive={false} setChantsCount={setChantsCount} />;
  };

  return (
    <div className="admin-chants-container" style={{ padding: "12px" }}>
      <ScreenHeader
        title="Chants"
        elementCount={chantsCount}
        actions={
          getCurrentTab() === "current" && (
            <div style={{ display: "flex", gap: "12px" }}>
              <ChantButton onClick={() => navigate("/clubadmin/chants/create")}>
                Create Chant
              </ChantButton>
            </div>
          )
        }
      />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>
      <div className="admin-chants-content">{renderContent()}</div>
    </div>
  );
};

export default ClubAdminChants;
